__webpack_require__.p = "https://widget.dolomites.bergregions.pl/";